<template>
    <div class="card">
        <header class="card-header">
            <p class="card-header-title">
                Graphique
            </p>
        </header>
        <div class="card-content">
            <div class="content">
                <div class="columns">
                    <div class="column">
                        <div class="field">
                            <div class="control has-icons-left">
                                <div class="select is-multiple">
                                    <select multiple size="4" v-model="optionsSelected">
                                        <option v-for="option in this.optionsInterfaces" :key="option.idOptionInterface" :value="option.idOptionInterface">{{option.libelle}}</option>
                                    </select>
                                </div>
                                <div class="icon is-small is-left">
                                    <i class="fas fa-weight"></i>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="column">
                        <periode v-model="periodeSaisie" @click="Afficher" />
                    </div>
                    <div class="column">
                        <div class="field">
                            <a class="button is-link" @click="Afficher">Afficher</a>
                        </div>
                    </div>                   
                </div>
                <highcharts :options="options" ref="highcharts"></highcharts>
            </div>
        </div>
    </div>
</template>

<script>
import UniteSymboleFilter from '../filters/uniteFilter'
import Periode from './Periode'

export default {  
    data() {
        return {
            options: {},
            optionsSelected: [],
            series: [],
            yAxis: [],
            periodeSaisie: {},
            optionsNetatmo: []
        }
    },
    components: {
        'periode': Periode
    },
    created () {
        this.options = {
            title: {
                text: ''
            },
            time: {
                useUTC: false
            },
            credits: {
                enabled: false
            },
            chart: {
                type: 'line',
                zoomType: 'x'
            },
            xAxis: {
                type: 'datetime',
            },
            tooltip: {
                shared: true
            },
            yAxis: this.yAxis,
            series: this.series
        }
        this.$store.dispatch('lireStatusThermostat')
        .then((status) => {
            if (!status.error) {
                this.creerOptionNetAtmo(-100, "Température", "CELSIUS", "30min", "temperature", true)
                this.creerOptionNetAtmo(-101, "Consigne", "CELSIUS", "30min", "sp_temperature", true)
                this.creerOptionNetAtmo(-102, "Taux d'utilisation", "POURCENT", "1hour", "sum_boiler_on,sum_boiler_off", false)
            }
        })
    },
    methods: {
        Afficher() {
            if (this.optionsSelected.length > 0) {
                // Suppression des séries existantes et axes
                this.series.splice(0, this.series.length)
                this.yAxis.splice(0, this.yAxis.length)

                // Séries temporaire pour éviter les flashs d'affichage
                let tmpseries = []

                this.optionsSelected.forEach((idOption) => {
                    // Recherche de l'interface
                    let option = this.optionsInterfaces.find(optionInterface => optionInterface.idOptionInterface == idOption)

                    // Série
                    let serie = {
                        name: option.libelle,
                        yAxis: option.idUnite,
                        tooltip: {
                            valueSuffix: " " + UniteSymboleFilter.symbole(option.idUnite)
                        },
                        data: []
                    }
                    
                    // Appel API pour interface ttbox
                    if (option.idTypeProtocole === "ttbox") {

                        let params = {
                            idOption: idOption,
                            periode: this.periodeSaisie.periode,
                            annee: this.periodeSaisie.annee,
                            mois: this.periodeSaisie.mois,
                            jour: this.periodeSaisie.jour
                        }

                        this.$store.dispatch('lireValeursOptionInterface', params)
                        .then((response) => 
                        {
                            response.forEach((valeur) => {
                                let point = [
                                    valeur.timestamp * 1000,
                                    Number(valeur.valeur.replace(",","."))
                                ]
                                serie.data.push(point)
                            })
                            if (option.idUnite === "BOOLEAN" || option.idUnite === "WATT" ) {
                                serie.data = this.affichageCarre(serie.data)
                            }
                            if (option.idUnite === "WATTH" ) {
                                serie.type = 'column'
                                serie.pointPadding = 0
                                serie.groupPadding = 0
                                serie.zIndex = -1
                                if (this.periodeSaisie.periode === 'J' ) {
                                    serie.pointRange = 3600 * 1000 *0.7
                                }
                                if (this.periodeSaisie.periode === 'M' ) {
                                    serie.pointRange = 3600 * 30 * 1000 *0.7
                                }
                                if (this.periodeSaisie.periode === 'A' ) {
                                    serie.pointRange = 3600 * 365 * 1000 *0.7
                                }
                            }
                        })
                        tmpseries.push(serie)
                    }
                    // Appel api netAtmo
                    if (option.idTypeProtocole === "netAtmo") {
                        let scale = option.scale
                        let type = option.type
                        if (this.periodeSaisie.periode === 'M')
                        {
                            scale = "1day"
                        }
                        if (this.periodeSaisie.periode === 'A')
                        {
                            scale = "1month"
                        }
                        let params = {
                            scale: scale,
                            type: type,
                            timestampDebut: this.periodeSaisie.timestampDebut / 1000,
                            timestampFin: this.periodeSaisie.timestampFin / 1000
                        }

                        let typeDispatch = option.room ? 'lireDonneesPieceNetAtmo' : 'lireDonneesNetAtmo'
                        this.$store.dispatch(typeDispatch, params)
                        .then((response) => {

                            for (let timestamp in response.data.body) {
                                let valeur = response.data.body[timestamp][0]
                                // Calcul du pourcentage d'utilisation
                                if ( response.data.body[timestamp][1] || response.data.body[timestamp][1] === 0 ){
                                    serie.type = 'column'
                                    serie.pointPadding = 0
                                    serie.groupPadding = 0
                                    serie.zIndex = -1
                                    valeur = (Math.round((response.data.body[timestamp][0] * 1000) / 
                                        (response.data.body[timestamp][0] + response.data.body[timestamp][1]))) / 10
                                    if (!serie.pointRange) {
                                        serie.pointRange = (response.data.body[timestamp][0] + response.data.body[timestamp][1]) * 700
                                    }
                                }
                                let point = [
                                    timestamp * 1000,
                                    valeur
                                ]
                                serie.data.push(point)
                            }
                        })
                        tmpseries.push(serie)
                    }

                    // Axe Y
                    let yAxi = {
                        id: option.idUnite,
                        title: {
                            text: ''//UniteSymboleFilter.libelle(option.idUnite)
                        },
                        labels: {
                            format: "{value} " + UniteSymboleFilter.symbole(option.idUnite)
                        },
                        opposite: this.oppositeYAxis()
                    }
                    if (option.idUnite === "BOOLEAN") {
                        yAxi.categories = ['0', '1']
                    }
                    if (option.idUnite === "POURCENT") {
                        yAxi.min = 0
                        yAxi.max = 100
                    }

                    if (!this.existYAxis(option.idUnite)) {
                        this.yAxis.push(yAxi)
                    }
                })

                // Recopie des serie de tmp vers la variable finale
                tmpseries.forEach(serie => this.series.push(serie))
            }
            
        },
        existYAxis(idUnite) {
            return this.yAxis.find(axis => axis.id == idUnite) != undefined
        },
        oppositeYAxis() {
            return this.yAxis.length % 2 != 0
        },
        affichageCarre(serie) {
            let serieCarre = []
            let precedenteValeur = 0
            serie.forEach((point) => {
                if (serieCarre.length === 0) {
                    // Le premier point est ajouté sans
                    // traitement
                    serieCarre.push(point)
                } else {
                    // Pour les points suivants, ajouter
                    // juste avant, un point avec l'ancienne
                    // valeur
                    let nouveauPoint = [
                        point[0] - 1,
                        precedenteValeur
                    ]
                    serieCarre.push(nouveauPoint)
                    serieCarre.push(point)
                }
                precedenteValeur = point[1]
            })
            return serieCarre
        },
        creerOptionNetAtmo(idOptionInterface, libelle, idUnite, scale, type, room) {
            let option = {
                libelle: "NetAtmo." + libelle,
                idUnite: idUnite,
                idOptionInterface: idOptionInterface,
                idTypeProtocole: "netAtmo",
                scale: scale,
                type: type,
                room: room
            }
            this.optionsNetatmo.push(option)
        }
    },
    computed:{
        optionsInterfaces() {
            return this.$store.getters.getOptionsInterfaces('E').concat(this.optionsNetatmo)
        }
    }
}
</script>

<style scoped>
.card {
    display: block;
}
</style>

<style>
.field, .select {
    width: 100%;
    margin-bottom: 10px;
    margin: 0px;
}

select {
    width: 100%;
}

</style>

